import { ChatCircleDots, FileText, BoundingBox } from "@phosphor-icons/react";
import { WidgetType } from "./types";

export const widgetTypes: WidgetType[] = [
  {
    id: "chatbot",
    name: "Chatbots",
    icon: <ChatCircleDots size={32} weight="regular" />,
    description:
      "Quickly access tools and support by adding a main chat shortcut, your personal chats, or the Fluxprompt chat.",
  },
  {
    id: "form",
    name: "Forms",
    icon: <FileText size={32} weight="duotone" />,
    description:
      "Quickly access tools and support by adding a form shortcut, or a form you have created for personal use",
  },
  {
    id: "agent",
    name: "Agents",
    icon: <BoundingBox size={32} weight="duotone" />,
    description:
      "Quickly access tools and support by adding a shortcut to all agents or a specific agent you have created and want to use more",
  },
];
